import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';

@Component({
    selector: 'app-ok-dialog',
    templateUrl: './ok-dialog.component.html',
    styleUrls: ['./ok-dialog.component.css'],
    standalone: false
})
export class OkDialogComponent {
  private readonly destroyRef = inject(DestroyRef);

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
         private keyboardService: KeyboardService,
      public dialogRef: MatDialogRef<OkDialogComponent>) { }
 ngOnInit(): void {

    this.keyboardService.onKey('Escape', () => {
    this.dialogRef.close();
  }, this.destroyRef);
  }

}
